import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PeCompanyFinanceHistoryTableRow from './PeCompanyFinanceHistoryTableRow';

interface Props {
  investments: PeCompanyInvestmentItem[];
}

const PeCompanyFinanceHistoryTable: FC<Props> = ({ investments }) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('peCompanyInvestmentsHistory')}</GridHeading>
      <AppCard p="20px">
        <TableContainer w="100%">
          <Table>
            <Thead>
              <Tr>
                <Th>{t('peFinanceHistoryDate')}</Th>
                <Th>{t('peFinanceHistoryType')}</Th>
                <Th>{t('peFinanceHistoryRaised')}</Th>
                <Th>{t('peFinanceHistoryLeadInvestors')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {investments.map((item, index) => (
                <PeCompanyFinanceHistoryTableRow key={index} {...item} />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </AppCard>
    </>
  );
};

export default PeCompanyFinanceHistoryTable;
